import { render, staticRenderFns } from "./TUWEN017.vue?vue&type=template&id=09a6d6e3"
import script from "./TUWEN017.vue?vue&type=script&lang=js"
export * from "./TUWEN017.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports